export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Offers"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My Trades"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My Ads"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trades"])}
}